import DetailContainer from './review-container';

export default DetailContainer;
